import React from 'react';
import PropTypes from 'prop-types';

export default function PermissionHeader({ title, tooltip }) {
  return (
    <th>
      <abbr className="tool-tip" data-original-title={tooltip}>{title}</abbr>
    </th>
  );
}

PermissionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
};